/* eslint-disable react-hooks/exhaustive-deps */
import {
  Alert,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  DialogContent,
  Grid,
  Snackbar,
  Stack,
  // IconButton,
  Typography,
} from "@common-ui/ui";
import {
  getUserOrgsRelated,
  getUserCustomers,
  getCustomerPlaces,
  getOrgPlaces,
} from "../../services";
// import { MoreVert } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { MainDialog } from "./MainDialog";
import PropTypes from "prop-types";
import { orderBy } from "lodash";
import { Dialog } from "@mui/material";

const ScopingHeader = ({ name, ...props }) => {
  const [mainDialog, setMainDialog] = useState({ isOpen: false });
  const [data, setData] = useState([]);
  const [remove, setRemove] = useState(undefined);
  // const [customer, setCustomer] = useState(props.customer);
  // const [places, setPlaces] = useState(props.places);
  const [isLoading, setIsLoading] = useState(true);
  const [placesParent, setPlacesParent] = useState(undefined);
  const [toast, setToast] = useState([]);
  const handleClose = () => {
    setMainDialog({ ...mainDialog, isOpen: false });
  };
  const handleOpen = () => {
    setMainDialog({ ...mainDialog, isOpen: true });
  };
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    props?.setNewPlaceParent && props?.setNewPlaceParent(placesParent);
  }, [placesParent]);

  const init = async () => {
    try {
      let internalOrgs = await getUserOrgsRelated();
      internalOrgs = [internalOrgs];
      // if (internalOrgs.length) {
      //   internalOrgs = internalOrgs.filter((org) => org.parent === null);
      // }
      // console.log("internals", internalOrgs);
      let externalOrgs = await getUserCustomers();
      // let externalOrgs = [];
      // console.log("externals", internalOrgs);
      const newData = orderBy(
        [...internalOrgs, ...externalOrgs],
        ["name"],
        ["asc"]
      );
      // console.log("newData", newData);
      setData(newData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(async () => {
    await getParent(props.customer);
  }, [props.customer, JSON.stringify(props.places)]);

  async function getParent(item) {
    if (!item) return;
    if (placesParent) return;
    try {
      let placesData = [];
      if (item.system_id) {
        placesData = await getCustomerPlaces(item.org, item.system_id);
      } else {
        placesData = await getOrgPlaces(item.id);
      }

      if (!props.places.length) {
        setPlacesParent(undefined);
      } else {
        if (!placesParent && props.places[0]) {
          function getParent(nodes, parent = undefined) {
            if (
              String(nodes.system_id).toLowerCase() ===
              String(props.places[0]).toLowerCase()
            ) {
              setPlacesParent(parent);
              return;
            } else if (Array.isArray(nodes.child_places)) {
              for (let childNode of nodes.child_places) {
                getParent(childNode, parent);
              }
            } else return;
          }
          for (let i = 0; i < placesData.length; i++) {
            getParent(placesData[i], placesData[i]);
          }
        }
      }
    } catch (error) {
      console.log(error);
      // alert(error);
    }
  }

  const handleRemove = () => {
    if (remove === "customer") {
      setPlacesParent(undefined);
      props.setPlaces([]);
      props.setCustomer(null);
      setToast([
        ...toast,
        {
          message: "Client has been removed successfully.",
          open: true,
          severity: "success",
        },
      ]);
      setRemove(undefined);
    } else {
      setPlacesParent(undefined);
      props.setPlaces([]);
      setToast([
        ...toast,
        {
          message: "Places has been removed successfully.",
          open: true,
          severity: "success",
        },
      ]);
      setRemove(undefined);
    }
  };
  return (
    <>
      {isLoading ? (
        "Loading..."
      ) : (
        <>
          <Box>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <Typography variant="h6">
                  {name}
                  {props.required ? (
                    <span>
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fillRule="evenodd">
                          <polygon
                            id="Shape"
                            fill="#EE2E24"
                            fillRule="nonzero"
                            points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                          ></polygon>
                        </g>
                      </svg>
                    </span>
                  ) : (
                    ""
                  )}
                </Typography>
                {props.customer ? (
                  <Card variant="outlined" sx={{ height: "150px" }}>
                    <CardHeader
                      action={
                        <Box sx={{ display: "flex" }}>
                          <Button
                            size="small"
                            sx={{ fontWeight: 200 }}
                            onClick={() => handleOpen()}
                          >
                            Change
                          </Button>
                          <Button
                            size="small"
                            sx={{ fontWeight: 200 }}
                            onClick={() => {
                              // setCustomer(null);
                              // setPlaces([]);
                              setRemove("customer");
                            }}
                          >
                            Remove
                          </Button>
                        </Box>
                      }
                    />
                    <CardContent
                      sx={{
                        // height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      // onClick={(e) => handleOpen()}
                    >
                      <Typography variant="body2" fontWeight="700">
                        {props.customer.name}
                      </Typography>
                    </CardContent>
                  </Card>
                ) : (
                  <Card variant="outlined">
                    <CardActionArea
                      sx={{
                        height: "150px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={(e) => handleOpen()}
                    >
                      <Typography variant="body2" fontWeight="700">
                        Select {name}
                      </Typography>
                      {/* <Add
                    sx={{
                      fontSize: 80,
                      color: (theme) => theme.palette.grey[800],
                    }}
                  /> */}
                    </CardActionArea>
                  </Card>
                )}
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography variant="h6">Place</Typography>
                {placesParent ? (
                  <Card variant="outlined" sx={{ height: "150px" }}>
                    <CardHeader
                      action={
                        <Box sx={{ display: "flex" }}>
                          <Button
                            size="small"
                            sx={{ fontWeight: 200 }}
                            onClick={() => handleOpen()}
                          >
                            Change
                          </Button>
                          <Button
                            size="small"
                            sx={{ fontWeight: 200 }}
                            onClick={() => {
                              // setPlaces([]);
                              setRemove("place");
                            }}
                          >
                            Remove
                          </Button>
                        </Box>
                      }
                    />
                    <CardContent
                      disabled
                      sx={{
                        // height: "150px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // backgroundColor: (theme) => theme.palette.grey[200],
                      }}
                    >
                      <Typography variant="body2" fontWeight="700">
                        {/* {`(${places.length}) Selected Place${
                          places.length > 1 ? "s" : ""
                        }`} */}
                        {placesParent ? placesParent.name : ""}
                      </Typography>
                    </CardContent>
                  </Card>
                ) : (
                  <Card variant="outlined">
                    <CardActionArea
                      disabled
                      sx={{
                        height: "150px",
                        backgroundColor: (theme) => theme.palette.grey[200],
                      }}
                    ></CardActionArea>
                  </Card>
                )}
              </Grid>
            </Grid>
          </Box>
          <MainDialog
            open={mainDialog.isOpen ? mainDialog.isOpen : false}
            name={name}
            data={data}
            handleClose={handleClose}
            setCustomer={props.setCustomer}
            setPlaces={props.setPlaces}
            places={props.places}
            customer={props.customer}
            placesParent={placesParent}
            setPlacesParent={setPlacesParent}
          />
          {toast.map((item, id) => {
            return (
              <Snackbar
                key={id}
                open={item.open}
                autoHideDuration={6000}
                onClose={() => {
                  setToast(toast.filter((v, i) => i !== id));
                }}
              >
                <Alert
                  onClose={() => {
                    setToast(toast.filter((v, i) => i !== id));
                  }}
                  severity={item.severity}
                  sx={{ width: "100%" }}
                  variant="filled"
                >
                  {item.message}
                </Alert>
              </Snackbar>
            );
          })}
          <Dialog
            open={remove ? remove : false}
            onClose={() => {
              setRemove(undefined);
            }}
            aria-labelledby="contact-remove"
            aria-describedby="contact-remove-dialog"
            fullWidth
          >
            <DialogContent>
              <Stack alignItems="left">
                {remove === "customer" ? (
                  <Typography variant="h4">
                    Removing the client will also remove selected Place
                    associations. Do you want to continue?
                  </Typography>
                ) : (
                  <Typography variant="h4">Remove Places selection?</Typography>
                )}
              </Stack>
              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="flex-end"
                spacing={{ xs: 1, md: 2 }}
                sx={{ px: 3, pt: 3 }}
              >
                <div>
                  <Button
                    color="primary"
                    size="small"
                    variant="text"
                    onClick={() => {
                      setRemove(undefined);
                    }}
                  >
                    No
                  </Button>
                </div>
                <div>
                  <Button
                    color="primary"
                    disabled={isLoading}
                    size="small"
                    variant="contained"
                    onClick={() => handleRemove()}
                  >
                    Yes
                  </Button>
                </div>
              </Stack>
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};

ScopingHeader.propTypes = {
  name: PropTypes.string,
  setCustomer: PropTypes.any,
  setPlaces: PropTypes.any,
  customer: PropTypes.object,
  places: PropTypes.array,
  setNewPlaceParent: PropTypes.any,
  open: PropTypes.any,
};

ScopingHeader.defaultProps = {
  name: "Client",
  customer: null,
  places: [],
};

export { ScopingHeader };
